export const WizardSessionFormat = {
  Video: 'video'
}
